var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"panel-block album"},[_c('span',{staticClass:"panel-icon"},[_c('font-awesome-icon',{attrs:{"icon":"compact-disc"}})],1),_vm._v("\n  "+_vm._s(_vm.album.name)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }